import { render, staticRenderFns } from "./print_kpqrd.vue?vue&type=template&id=3968ca0c&scoped=true&"
import script from "./print_kpqrd.vue?vue&type=script&lang=js&"
export * from "./print_kpqrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968ca0c",
  null
  
)

export default component.exports